module.exports = __webpack_public_path__ + "static/media/rootsbranches.376b1a9d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/rootsbranches.webp
// module id = 565
// module chunks = 0